import { Suspense, useEffect, useState } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

export const CountryRoutes = () => {
  const { country } = useParams();
  const allowedCountries = ["belgique", "belgie"];
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (allowedCountries.includes(country)) ? (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  ) : (
    mounted ? <Navigate to='/' /> : null
  );
};
